module.exports = __webpack_public_path__ + "img/dropdown-icon.8ee163a8.svg";